import { Component, OnInit , AfterViewInit} from '@angular/core';
declare var $:any;

@Component({
  selector: 'app-school-uniform',
  templateUrl: './school-uniform.component.html',
  styleUrls: ['./school-uniform.component.scss']
})
export class SchoolUniformComponent implements OnInit, AfterViewInit {
  isLoading:boolean[]=[];
  imgUrl:string[]=[
    '/assets/img/rules/u1.jpg',
    '/assets/img/rules/u2.jpg',
    '/assets/img/rules/u3.jpg',
    '/assets/img/rules/u4.jpg',
    '/assets/img/rules/u5.jpg',
    '/assets/img/rules/u6.jpg',
  ]

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    $('.carousel').carousel({
      interval: 3000, //set the initial interval
      pause:false
  });
  }
  setLoader(){
    for(let i=0;i<this.imgUrl.length;i++){
      this.isLoading.push(true);
    }
  }
  hideLoader(i:number){
    this.isLoading[i]=false;
  }

}
